import { useState, useEffect } from 'react';
import { X, Users, ScrollText, Activity } from 'lucide-react';
import { UsersTab } from './manage/UsersTab';
import { AuditLogTab } from './manage/AuditLogTab';
import { TrackerLogTab } from './manage/TrackerLogTab';
type ManageTab = 'users' | 'audit-log' | 'tracker-log';
interface ManageModalProps {
  onClose: () => void;
}
const TABS: {
  key: ManageTab;
  label: string;
  icon: React.ReactNode;
}[] = [{
  key: 'users',
  label: 'Users',
  icon: <Users size={16} data-id="element-408" data-mp="2lyd71nmx7thw" />
}, {
  key: 'audit-log',
  label: 'Audit Log',
  icon: <ScrollText size={16} data-id="element-409" data-mp="2h25z5pays7xb" />
}, {
  key: 'tracker-log',
  label: 'Tracker Log',
  icon: <Activity size={16} data-id="element-410" data-mp="2c1i9b6yh1x4o" />
}];
export function ManageModal({
  onClose
}: ManageModalProps) {
  const [activeTab, setActiveTab] = useState<ManageTab>('users');

  // Close on Escape key
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);
  return <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto py-4 px-2" style={{
    background: 'rgba(0,0,0,0.55)'
  }} onClick={onClose} data-id="element-411" data-mp="1sxn3q7sdhoz6">
      <div className="relative bg-white rounded-xl shadow-2xl w-full flex flex-col" style={{
      maxWidth: '98vw',
      height: '95vh'
    }} onClick={e => e.stopPropagation()} data-id="element-412" data-mp="1ezyi2xqhedt2">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200" data-id="element-413" data-mp="19ysoyyswsoj0">
          <h2 className="text-lg font-semibold text-slate-900" data-id="element-414" data-mp="v9wl7dxvxxo7">Manage</h2>
          <button onClick={onClose} className="p-1 rounded-md hover:bg-slate-100 text-slate-400 hover:text-slate-600 transition-colors" data-id="element-415" data-mp="v7tj3vjgke34">
            <X size={20} data-id="element-416" data-mp="maj6a5qzsgw3" />
          </button>
        </div>

        {/* Body: sidebar + content */}
        <div className="flex flex-1 min-h-0" data-id="element-417" data-mp="r6zwr6lnz7cc">
          {/* Left sidebar */}
          <nav className="w-48 border-r border-slate-200 bg-slate-50 flex-shrink-0" data-id="element-418" data-mp="2sxqlbjeo5m8v">
            <div className="py-3" data-id="element-419" data-mp="2o68kcvcnblnw">
              {TABS.map(tab => <button key={tab.key} onClick={() => setActiveTab(tab.key)} className={`w-full flex items-center gap-2.5 px-4 py-2.5 text-sm font-medium transition-colors ${activeTab === tab.key ? 'bg-indigo-50 text-indigo-700 border-r-2 border-indigo-600' : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900'}`} data-id="element-420" data-mp="2o4xhqyuxsjyd">
                  {tab.icon}
                  {tab.label}
                </button>)}
            </div>
          </nav>

          {/* Content area */}
          <div className="flex-1 overflow-y-auto p-6" data-id="element-421" data-mp="1rgrheo51sdpw">
            {activeTab === 'users' && <UsersTab data-id="element-422" data-mp="1mho9mvxonte8" />}
            {activeTab === 'audit-log' && <AuditLogTab data-id="element-423" data-mp="1mg3g99n3ughy" />}
            {activeTab === 'tracker-log' && <TrackerLogTab data-id="element-424" data-mp="205e9rzjmws9" />}
          </div>
        </div>
      </div>
    </div>;
}